<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      @if (!workDayId) {
      <ion-button (click)="createTimeEntry()" [disabled]="!inputsValid()">{{
        "hours.create" | translate
      }}</ion-button>
      } @if (workDayId) {
      <ion-button (click)="updateTimeEntry()" [disabled]="!inputsValid()">{{
        "hours.update" | translate
      }}</ion-button>
      }
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="container">
    @if (state.userHasMinType(1)) {
    <div class="select-form">
      @if (!workDayId) {
      <lib-user-picker
        [users]="this.state.users$"
        [showAllEntry]="false"
        [multiple]="true"
        (selectedUserChanged)="userChange($event)"
      ></lib-user-picker>
      } @if (workDayId) {
      <lib-user-picker
        [disabled]="workDayId != null"
        [users]="this.state.users$"
        [showAllEntry]="false"
        (selectedUserChanged)="userChange($event)"
        [preselectedUsers]="newWorkDay.user"
      ></lib-user-picker>
      }
    </div>
    }

    <div class="select-form wide">
      <div>{{ "hours.workDate" | translate }}</div>
      <div>{{ "hours.totalTime" | translate }}</div>
    </div>
    <div class="select-form wide">
      <lib-date-time-picker
        [type]="'date'"
        [disabled]="isAnyApproved()"
        [inputDateZulu]="newWorkDay.workingDate"
        (selectedDateChanged)="workDayDateChanged($event)"
      ></lib-date-time-picker>
      <div>{{ fullDayWorked }}</div>
    </div>

    @for (usr of usersWithExistingWorkDays; track usr) {
    <div class="existing-workdays danger wide">
      {{
        "hours.alreadyExists"
          | translate : { name: (state.getUserDisplayNameAsync(usr) | async) }
      }}
    </div>
    } @if(usersWithExistingWorkDays?.length != 1){
    <h4>{{ "common.constructionSites" | translate }}:</h4>
    @for (workEntry of this.newWorkDay.workEntries; track workEntry; let i =
    $index) {
    <div class="work-entry">
      @if (workEntry.approvedBy != null && this.workDayId) {
      <div style="padding: 5px">
        <div class="stretch" style="font-weight: 500">
          <div>
            {{ state.getConstructionSiteName(workEntry.constructionSite) }}
          </div>
          <div>
            {{ workEntry.durationInHours }}H {{ workEntry.durationInMins }}M
          </div>
        </div>
        @if (workEntry?.description && workEntry.description != '') {
        <div class="stretch">
          <div>{{ "common.description" | translate }}:</div>
          <div style="padding-left: 10px">{{ workEntry.description }}</div>
        </div>
        }
        <!--div>Arbeitszeiten:</div-->
        <div class="stretch">
          <div>{{ "common.startTime" | translate }}</div>
          <div>{{ "common.endTime" | translate }}</div>
        </div>
        @for (entry of workEntry.timeEntries; track entry; let i = $index) {
        <div class="stretch">
          <div>{{ tools.formatTime(entry.start) }}</div>
          <div>-</div>
          <div>{{ tools.formatTime(entry.end) }}</div>
        </div>
        } @if (workEntry.approvedBy) {
        <div class="centered">
          {{ "common.status" | translate }}:
          {{ "status.confirmed" | translate }}
          <ion-icon
            style="color: rgb(0, 179, 0)"
            name="checkmark-circle-outline"
          ></ion-icon>
        </div>
        }
      </div>
      } @if (workEntry.approvedBy == null || this.workDayId == null) {
      <div>
        <div class="select-form-flex">
          <lib-construction-site-picker
            style="width: 100%"
            [conSites]="state.conSites$"
            [preselectedConSite]="workEntry.constructionSite"
            [showAllEntry]="false"
            [blackList]="getSelectedConSiteIds()"
            (selectedConSiteChanged)="conSiteChange($event, workEntry)"
          ></lib-construction-site-picker>
          <ion-icon
            style="font-size: 30px; margin: 0 0 0 20px"
            (click)="removeConSite(workEntry)"
            name="trash-outline"
          ></ion-icon>
        </div>
        <div class="select-form">
          <ion-textarea
            [label]="'common.description' | translate"
            labelPlacement="floating"
            fill="outline"
            mode="md"
            [(ngModel)]="workEntry.description"
            [placeholder]="'common.addDescription' | translate"
          ></ion-textarea>
        </div>
        <div class="wide select-form">
          <div>{{ "hours.workTime" | translate }}</div>
          <div>{{ this.tools.calculateHours(workEntry.timeEntries) }}</div>
        </div>
        <div class="wide select-form">
          <div>{{ "common.startTime" | translate }}</div>
          <div></div>
          <div>{{ "common.endTime" | translate }}</div>
          <div></div>
        </div>
        @for (entry of workEntry.timeEntries; track entry; let i = $index) {
        <div class="wide" style="margin: 10px 10px">
          <!--input type="time" [(ngModel)]="entry.start" /-->
          <lib-date-time-picker
            [type]="'time'"
            [inputDateZulu]="entry.start"
            (selectedDateChanged)="timeEntryStartChanged(entry, $event)"
          ></lib-date-time-picker>
          <span>-</span>
          <!--input type="time" [(ngModel)]="entry.end" /-->
          <lib-date-time-picker
            [type]="'time'"
            [inputDateZulu]="entry.end"
            [hourDelay]="1"
            (selectedDateChanged)="timeEntryEndChanged(entry, $event)"
          ></lib-date-time-picker>
          <ion-icon
            style="font-size: 22px"
            (click)="removeTimeEntry(workEntry.timeEntries, i)"
            name="trash-outline"
          ></ion-icon>
        </div>
        } @if (tools.timeEntriesInvalid(workEntry.timeEntries)) {
        <div class="time-entry-error danger">
          {{ "hours.endBeforeStart" | translate }}
        </div>
        }
        <div style="display: flex; justify-content: center">
          <ion-icon
            (click)="addTimeEntry(workEntry)"
            name="add-outline"
          ></ion-icon>
        </div>
      </div>
      }
    </div>
    }

    <div style="display: flex; justify-content: center">
      <!--ion-icon (click)="addWorkEntry()" name="add-outline"></ion-icon-->
      <ion-button (click)="addWorkEntry()">{{
        "common.addConstructionSite" | translate
      }}</ion-button>
    </div>
    }
    <!--div style="margin-bottom: 10px">
      <ion-button
        style="width: 100%"
        (click)="createTimeEntry()"
        [disabled]="!inputsValid()"
        *ngIf="!workDayId"
        >Arbeitszeit anlegen</ion-button
        >
        <ion-button
          style="width: 100%"
          (click)="updateTimeEntry()"
          [disabled]="!inputsValid()"
          *ngIf="workDayId"
          >Arbeitszeit aktualisieren</ion-button
          >
        </div-->
  </div>
</ion-content>
